import { default as React, useEffect, useState } from "react";
import { connect } from "react-redux";
import { differenceInYears, format } from "date-fns";

import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import { KycNotDoneDialog } from "../../customModal";
import { NEW_TRANSACTION_URL } from "..";
import {
  getCountriesList,
  getStatesList,
  storeApplicantParams,
  getKycDetails,
  checkKyc,
  getCitiesList as getCitiesByState,
  getRelationShipList,
  storePan,
  getNewPurchaseFundList,
  checkPAN,
} from "../../../../store/actions";
import {
  getFieldsFromMap,
  getFieldList,
  $wait,
  checkIfMinor,
} from "./lib/utils";

import CardComponent from "./lib/CardComponent";
import CustomLoader from "../../../forms/Loader";
import AutoField from "./lib/AutoField";
import {
  countryCodeRegex,
  emailRegex,
  mobileRegex,
  nameRegex,
  panRegex,
  categoryOptions,
  genderOptions,
  familyDescriptionOptions,
  relationshipOptions,
  restrictedCountriesForCapitalMindAMC,
} from ".";
import { useLocation } from "react-router-dom";

const YES = "Yes";
const INDIVIDUAL = "individual";

const investorOptions = [
  { name: "Individual", value: INDIVIDUAL },
  { name: "Minor", value: "minor" },
];

const InvestorDetails = (props) => {
  const { state } = useLocation();
  const SINGLE_APPLICANT = "single";
  const initialFormValues = {
    modeOfHolding: SINGLE_APPLICANT,
    kycCompleted_1: YES,
  };
  const [amcList, setamcList] = useState([]);
  const [countries, setCountries] = useState([]);

  const [cachedState, setCachedState] = useState({});

  const [investortype, setInvestorType] = useState({
    investorType: INDIVIDUAL,
  });
  const [formValues, setFormValues] = useState(initialFormValues);
  const MAX_APPLICANTS = 3;

  const [disabledFields, setDisabledFields] = useState({});

  const validateSecondPan = (secondPan) => {
    const firstPan = formValues.pan_1;
    const thirdPan = formValues.pan_3;
    let error;
    if (firstPan === secondPan) {
      setFieldValue("pan_2", "");
      error = "PAN of the First Joint Holder should not be same as PAN 1";
      const id = document.getElementById("pan_2Field");
      id.focus();
    } else if (secondPan.length > 3 && secondPan[3] !== "P") {
      // setFieldValue("pan_2", "");
      error =
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number";
      const id = document.getElementById("pan_2Field");
      id.focus();
    } else if (secondPan === thirdPan) {
      setFieldValue("pan_3", "");
    } else {
      const isValid = panRegex.test(secondPan || "");
      if (!isValid) {
        error = "Please enter a valid PAN";
      }
    }
    return error;
  };

  const validateThirdPan = (thirdPan) => {
    const firstPan = formValues.pan_1;
    const secondPan = formValues.pan_2;
    let error;
    if (firstPan === thirdPan) {
      setFieldValue("pan_3", "");
      error = "PAN of the Second Joint Holder should not be same as PAN 1";
      const id = document.getElementById("pan_3Field");
      id.focus();
    } else if (secondPan === thirdPan) {
      setFieldValue("pan_3", "");
      error =
        "PAN of the Second Joint Holder should not be same as First Joint Holder";
      const id = document.getElementById("pan_3Field");
      id.focus();
    } else if (thirdPan.length > 3 && thirdPan[3] !== "P") {
      // setFieldValue("pan_3", "");
      error =
        "Entered PAN Number is not related to Individual PAN Number, So please Enter Individual PAN Number";
      const id = document.getElementById("pan_3Field");
      id.focus();
    }
    if (!!thirdPan && !panRegex.test(thirdPan)) {
      error = "Please enter a valid PAN";
    }
    return error;
  };
  console.log({ state });
  const applicantSchema = {
    fund: {
      name: "Fund",
      type: "select",
      isRequired: true,
      options: amcList,
      hidden: props.isCartUser && Boolean(state.transactionType),
    },
    pan: {
      name:
        investortype.investorType != "minor"
          ? "PAN of Primary Holder"
          : "Minor PAN",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter PAN of First Applicant",
      validate: panRegex,
    },
    name: {
      name:
        investortype.investorType != "minor"
          ? "Name (As per PAN)"
          : "Minor Name",
      isRequired: true,
      placeholder: "Enter Name",
      validate: nameRegex,
    },
    dob: {
      name: "Date of Birth (As per PAN)",
      type: "date",
      isRequired: true,
    },
    emailFamily: {
      name: "Email Family Description",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      default: "SE",
      options: familyDescriptionOptions,
    },
    email: {
      name: "Email ID",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Email ID",
      validate: emailRegex,
    },
    gender: {
      name: "Gender",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      options: genderOptions,
    },

    category: {
      name: "Category",
      type: "select",
      options:
        investortype.investorType === "minor"
          ? categoryOptions.filter((option) => option.value !== "20")
          : categoryOptions,
      isRequired: investortype.investorType === "minor" ? false : true,
    },
    countrycode: {
      name: "Country Code",
      validate: countryCodeRegex,
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Country Code",
      default: "+91",
      type: "countrycode",
    },
    mobileFamily: {
      name: "Mobile Family Description",
      type: "select",
      isRequired: investortype.investorType === "minor" ? false : true,
      default: "SE",
      options: familyDescriptionOptions,
    },
    mobile: {
      name: "Mobile Number",
      isRequired: investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Mobile Number",
      validate: mobileRegex,
    },
    guardianname: {
      name: "Guardian Name",
      isRequired: true,
      placeholder: "Enter Guardian Name",
      validate: nameRegex,
      hidden: true,
    },
    guardianpan: {
      name: "Guardian PAN",
      isRequired: true,
      placeholder: "Enter PAN of First Applicant",
      validate: panRegex,
      hidden: true,
    },
    guardiandob: {
      name: "Guardian Date of Birth",
      type: "date",
      isRequired: true,
      hidden: true,
    },
    guardiancategory: {
      name: "Guardian Category",
      type: "select",
      isRequired: true,
      options: categoryOptions,
      hidden: true,
    },
    guardianemailFamily: {
      name: "Guardian Email Family Description",
      type: "select",
      isRequired: true,
      default: "SE",
      options: familyDescriptionOptions,
      hidden: true,
    },
    guardianemail: {
      name: "Guardian Email ID",
      isRequired: true,
      placeholder: "Enter Guardian Email ID",
      validate: emailRegex,
      hidden: true,
    },
    guardianmobileFamily: {
      name: "Guardian Mobile Family Description",
      type: "select",
      isRequired: true,
      default: "SE",
      options: familyDescriptionOptions,
      hidden: true,
    },
    guardianmobile: {
      name: "Guardian Mobile Number",
      isRequired: true,
      placeholder: "Enter Guardian Mobile Number",
      validate: mobileRegex,
      hidden: true,
    },
    guardianRelationship: {
      name: "Guardian Relationship with Minor",
      type: "select",
      isRequired: true,
      options: relationshipOptions,
      hidden: true,
    },
    /*     seafarerFlag: {
      name: "SeaFarer Flag",
      isRequired: false,
      options: [
        { name: "Yes", value: true },
        { name: "No", value: false },
      ],
      hidden: true,
      type: "choice",
      nextEmpty: true,
    } */ address1: {
      name: "Address1",
      isRequired: false, 
      placeholder: "Enter Address",
      hidden: true,
    },
    address2: {
      name: "Address2",
      isRequired: false, 
      placeholder: "Enter Address",
      hidden: true,
    },
    city: {
      name: "City",
      isRequired: false, 
      placeholder: "Enter City",
      validate: nameRegex,
      hidden: true,
    },
    state: {
      name: "State",
      isRequired: false, 
      placeholder: "Enter State",
      validate: nameRegex,
      hidden: true,
    },

    country: {
      name: "Country",
      isRequired: false, //investortype.investorType === "minor" ? false : true,
      placeholder: "Enter Country",
      hidden: true,
      type: "select",
      options: countries.filter((ele) => {
        if (formValues?.fund_1 === "183" || state?.fund === "183") {
          return !restrictedCountriesForCapitalMindAMC.some(
            (restricted) => restricted.value === ele.value
          );
        }
        return true;
      }),
    },

    zipCode: {
      name: "ZipCode",
      isRequired: false,
      placeholder: "Enter ZipCode",
      hidden: true,
    },
  };

  const allFieldsMax = getFieldList({
    ...getFieldsFromMap("", applicantSchema, MAX_APPLICANTS),
  });

  for (let f of allFieldsMax) {
    initialFormValues[f.key] = initialFormValues[f.key] || f.default || "";
  }

  const [errors, setErrors] = useState({});

  const showJointHolders = formValues.modeOfHolding !== SINGLE_APPLICANT;
  const noOfApplicants = showJointHolders ? 3 : 1;

  const applicantFields = getFieldsFromMap(
    "",
    applicantSchema,
    noOfApplicants,
    (field, i, k) => {
      if (i > 1) {
        if (k === "fund") {
          field.hidden = true;
          field.isRequired = false;
        }
        // if (k === "category") {
        //   field.hidden = true;
        // }
        const pan2 = formValues[`pan_${i}`];
        const panNotFilled = !pan2 || errors[`pan_${i}`];
        if (k === "pan") {
          field.name =
            i === 2 ? "PAN of Joint Holder 1" : "PAN of Joint Holder 2";
          field.validate = validateSecondPan;
        } else if (panNotFilled) {
          field.hidden = true;
        }
        if (i > 2) {
          if (k == "pan") {
            if (formValues.pan_2 && !errors.pan_2) {
              field.hidden = false;
              field.validate = validateThirdPan;
            } else {
              field.hidden = true;
              field.validate = null;
            }
            field.isRequired = false;
          }
        }
      }
      const category = formValues[`category_${i}`];
      // const seafarerFlag = formValues[`seafarerFlag_${i}`];
      const nriFields = [
        "address1",
        "address2",
        "state",
        "country",
        "city",
        "zipCode",
      ];
      const minorFields = [
        "guardianname",
        "guardianpan",
        "guardiandob",
        "guardiancategory",
        "guardianemailFamily",
        "guardianemail",
        "guardianmobileFamily",
        "guardianmobile",
        "guardianmobileFamily",
        "guardianRelationship",
      ];
      if (category === "20") {
        // const isSeaFarer = k === "seafarerFlag";
        // if (isSeaFarer) field.hidden = false;
        /*   if (seafarerFlag === "Yes") {
          const isNriField = nriFields.some((fieldName) => fieldName === k);
          if (!!isNriField) {
            field.hidden = true;
            field.isRequired = false;
          }
        } */
        const isNriField = nriFields.some((fieldName) => fieldName === k);
        if (!!isNriField) {
          field.hidden = false;
          field.isRequired = k !== "zipCode";
        }

        /*         if (seafarerFlag === "No") {
          const isNriField = nriFields.some((fieldName) => fieldName === k);
          if (!!isNriField) {
            field.hidden = false;
            field.isRequired = true;
          }
        } */
      }
      if (investortype.investorType === "minor") {
        const isMinorFields = minorFields.some((fieldName) => fieldName === k);
        if (!!isMinorFields) field.hidden = false;
      }
    }
  );
  const checkIfNri = (n) => {
    const categoryKey = `category_${n}`;
    return formValues[categoryKey] === "20";
  };

  const validateField = async (field, value) => {
    const validate =
      (field.key === "mobile_2" && formValues.countrycode_2 !== "+91") ||
      (field.key === "mobile_3" && formValues.countrycode_3 !== "+91")
        ? new RegExp(/^[0-9]*$/)
        : field.validate;
    let isValid = true;
    let forDifferentMessage1 = true;
    let forDifferentMessage2 = true;
    let errorMessage = "";
    const isInvestorMobileField = field.key.includes("mobile_");
    const isGuardianField = field.key.includes("guardianpan_");
    if (!value && field.isRequired && !field.hidden) {
      errorMessage = `${field.name} is required to proceed.`;
    } else if (typeof validate == "function") {
      field.key.includes("nom_email")
        ? (errorMessage = validate(field, value))
        : (errorMessage = validate(value));
    } else if (typeof validate == "object" && field.isRequired) {
      const validationRegex = validate;
      isValid = validationRegex.test(value || "");
      if (isValid && field.key == "email_1") {
        isValid = value.includes(".");
      }
    } else if (typeof validate == "object" && !!value) {
      const validationRegex = validate;
      isValid = validationRegex.test(value);
    }
    if (isInvestorMobileField) {
      const isNri = checkIfNri(field.key.split("_")[1]);
      if (isNri) {
        isValid = /^[0-9]*$/.test(value);
      }
    }
    if (isGuardianField) {
      const match = field.key.match(/guardianpan_(\d+)/);

      if (match) {
        const number = match[1];
        const compareKey = `pan_${number}`;

        if (formValues[field.key] === formValues[compareKey]) {
          errorMessage = `Guardian pan and minor pan cannot be same.`;
        }
      }
    }
    // const isGuardianEmailField = field.key.includes("guardianemail_1");
    // const minorMail = formValues.email_1;

    // const isSameMail =
    //   isGuardianEmailField &&
    //   formValues[field.key] === minorMail &&
    //   !!minorMail;

    // if (isSameMail) {
    //   errorMessage = "Guardian email and minor email cannot be same";
    // }
    // const isGuardianMobileField = field.key.includes("guardianmobile_1");
    // const minorMobile = formValues.mobile_1;

    // const isSameMobile =
    //   isGuardianMobileField && formValues[field.key] === minorMobile;

    // if (isSameMobile) {
    //   errorMessage = "Guardian mobile and minor mobile cannot be same";
    // }

    if (
      (field.key === "guardianpan_1" && formValues.pan_1 === value) ||
      (field.key === "pan_1" && formValues.guardianpan_1 === value)
    ) {
      forDifferentMessage1 = false;
      errorMessage = `Minor PAN and Guardian PAN should not be the same`;
    }
    if (
      (field.key === "guardianname_1" && formValues.name_1 === value) ||
      (field.key === "name_1" && formValues.guardianname_1 === value)
    ) {
      forDifferentMessage2 = false;
      errorMessage = `Minor Name and Guardian Name should not be the same`;
    }
    if (!isValid) {
      errorMessage = `Please enter a valid ${field.name}`;
    }
    setFieldError(field.key, errorMessage);
    await $wait(10);
    if (errorMessage) {
      return { [field.key]: errorMessage };
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [displayModal1, setDisplayModal1] = useState(false);
  const [displayModal2, setDisplayModal2] = useState(false);

  const [previouslyCheckedPAN, setPreviouslyCheckedPAN] = useState({
    pan_2: "",
    pan_3: "",
  });

  const applicantFieldList = getFieldList(applicantFields);
  const allFields = [...applicantFieldList];

  const removeJointHolderDetails = () => {
    try {
      const newFormValues = formValues;
      const jointHoldersFields = [...applicantFieldList];
      for (let f of jointHoldersFields) {
        if (["_2", "_3"].some((num) => f.key.includes(num))) {
          delete newFormValues[f.key];
        }
      }
      setFormValues(newFormValues);
    } catch (error) {
      console.error(error);
    }
  };

  const prefillFormValues = async () => {
    const { location } = props;
    const { state } = location;

    if (!!state && !!state.pan && !props.applicantparams.i_fname) {
      setIsLoading(true);
      const { pan } = state;
      try {
        const kycResponse = await props.getKycDetails({ pan });
        const { DtData } = kycResponse;
        const kycDetails = DtData[0];
        for (let key in kycDetails) {
          const val = kycDetails[key];
          if (!val) {
            key === "country"
              ? (kycDetails[key] = "India")
              : (kycDetails[key] = "");
          }
        }

        const { name1, gender, dob, email, mobile, app_cat } = kycDetails;
        const isMajor =
          differenceInYears(new Date(), new Date(parseInt(dob.substr(6)))) >=
          18;
        const kycFormValues = {
          name_1: name1,
          pan_1: pan,
          dob_1: !!dob && isMajor ? formatDateAsIST(dob.substr(6)) : "",
          email_1: email,
          gender_1: gender,
          mobile_1: mobile.trim(),
          category_1: app_cat === "22" ? "20" : app_cat,
          status_1: +app_cat === 11 ? "I" : +app_cat > 20 ? "N" : "",
        };

        setFormValues((prev) => {
          return { ...prev, ...kycFormValues };
        });
        setDisabledFields((prev) => {
          return {
            ...prev,
            pan_1: investortype.investorType != "minor" ? true : false,
            kycCompleted_1: true,
            status_1: true,
            // name_1: investortype.investorType != "minor" ? true : false,
          };
        });
      } catch (err) {
        setFormValues((prev) => {
          return {
            ...prev,
            pan_1: pan,
          };
        });

        setDisabledFields((prev) => {
          return {
            ...prev,
            pan_1: true,
            kycCompleted_1: true,
            status_1: true,
          };
        });
      } finally {
        setIsLoading(false);
      }
    }

    if (state && state?.cartItems?.length) {
      const [firstCartItem = {}] = state.cartItems;
      const { payload = {} } = firstCartItem;
      const { invCategory, email, mobile, familyEmailFlag, familyMobileFlag } =
        payload;
      const kycFormValues = {
        email_1: email,
        mobile_1: mobile.trim(),
        emailFamily_1: familyEmailFlag,
        mobileFamily_1: familyMobileFlag,
        category_1: invCategory,
      };
      setFormValues((prev) => ({ ...prev, ...kycFormValues }));
      setDisabledFields((prev) => ({
        ...prev,
        email_1: true,
        mobile_1: true,
        emailFamily_1: true,
        mobileFamily_1: true,
        category_1: true,
      }));
      return;
    }

    if (state && state?.requestBody) {
      const { invCategory, email, mobile, familyEmailFlag, familyMobileFlag } =
        state.requestBody;
      const kycFormValues = {
        email_1: email,
        mobile_1: mobile.trim(),
        emailFamily_1: familyEmailFlag,
        mobileFamily_1: familyMobileFlag,
        category_1: invCategory,
      };
      setFormValues((prev) => ({ ...prev, ...kycFormValues }));
      setDisabledFields((prev) => ({
        ...prev,
        email_1: true,
        mobile_1: true,
        emailFamily_1: true,
        mobileFamily_1: true,
        category_1: true,
      }));
      return;
    }
  };
  const gotoEkyc = (pan) => {
    props.history.replace(NEW_TRANSACTION_URL + `/new-investor/ekyc/${pan}`);
  };

  const invCategory = state?.cartItems?.length
    ? state.cartItems[0].payload.invCategory
    : state && state?.requestBody
    ? state.requestBody.invCategory
    : "";
  const checkReduxStore = async () => {
    const { applicantparams } = props;
    const {
      i_category,
      i_dob,
      i_email,
      i_email3,
      i_fname,
      i_invgender,
      i_mobileno,
      i_pangno,
      fEmailFlag,
      fMobileFlag,
      typeofinvestor,
      JHfEmailFlag1,
      JHfMobileFlag1,
      JHfEmailFlag2,
      JHfMobileFlag2,
      i_genMOH,
      i_pangno2,
      i_jholder1,
      i_invgender2,
      i_jh1dob,
      i_category2,
      i_mobileno2,
      i_pangno3,
      i_jholder2,
      i_email2,
      i_invgender3,
      i_jh2dob,
      i_category3,
      i_mobileno3,
      i_shnriadd1,
      i_shnriadd2,
      i_shnricity,
      i_shnristate,
      i_shnricountry,
      i_jhnriadd1,
      i_jhnriadd2,
      i_jhnricity,
      i_jhnristate,
      i_jhnricountry,
      i_nriadd1,
      i_nriadd2,
      i_nricity,
      i_nristate,
      i_nricountry,
      i_guardianname,
      i_guardiandob,
      i_guardiancategory,
      i_guardianpan,
      i_guadianmobile,
      i_guardianemail,
      i_guardianEmailFlag,
      i_guardianMobileFlag,
      i_guardianrelationship,
      seafarerFlag,
      fund,
      i_nrizipcode
    } = applicantparams;
    if (!!props.applicantparams.i_fname) {
      setFormValues({
        ...formValues,
        [`name_1`]: i_fname,
        [`pan_1`]: i_pangno,
        [`dob_1`]: i_dob,
        [`gender_1`]: i_invgender,
        [`email_1`]: i_email,
        [`mobile_1`]: i_mobileno,
        [`category_1`]: i_category,
        [`emailFamily_1`]: fEmailFlag,
        [`mobileFamily_1`]: fMobileFlag,
        [`modeOfHolding`]: i_genMOH === "1" ? "single" : "anyone",
        [`fund_1`]: fund,
        [`zipCode_1`]:i_nrizipcode,
        ...(!!i_pangno2 && {
          [`name_2`]: i_jholder1,
          [`pan_2`]: i_pangno2,
          [`dob_2`]: i_jh1dob,
          [`gender_2`]: i_invgender2,
          [`email_2`]: i_email2,
          [`mobile_2`]: i_mobileno2,
          [`category_2`]: i_category2,
          [`emailFamily_2`]: JHfEmailFlag1,
          [`mobileFamily_2`]: JHfMobileFlag1,
        }),
        ...(!!i_pangno3 && {
          [`name_3`]: i_jholder2,
          [`pan_3`]: i_pangno3,
          [`dob_3`]: i_jh2dob,
          [`gender_3`]: i_invgender3,
          [`email_3`]: i_email3,
          [`mobile_3`]: i_mobileno3,
          [`category_3`]: i_category3,
          [`emailFamily_3`]: JHfEmailFlag2,
          [`mobileFamily_3`]: JHfMobileFlag2,
        }),
        ...(i_category === "20" //&& seafarerFlag === "No"
          ? {
              [`address1_1`]: i_nriadd1,
              [`address2_1`]: i_nriadd2,
              [`city_1`]: i_nricity,
              [`state_1`]: i_nristate,
              [`country_1`]: i_nricountry,
              // seafarerFlag_1: "No",
            }
          : {
              // seafarerFlag_1: seafarerFlag,
            }),
        ...(i_category2 === "20" && {
          [`address1_2`]: i_jhnriadd1,
          [`address2_2`]: i_jhnriadd2,
          [`city_2`]: i_jhnricity,
          [`state_2`]: i_jhnristate,
          [`country_2`]: i_jhnricountry,
        }),
        ...(i_category3 === "20" && {
          [`address1_3`]: i_shnriadd1,
          [`address2_3`]: i_shnriadd2,
          [`city_3`]: i_shnricity,
          [`state_3`]: i_shnristate,
          [`country_3`]: i_shnricountry,
        }),
        ...(typeofinvestor === "M" && {
          [`guardianname_1`]: i_guardianname,
          [`guardiandob_1`]: i_guardiandob,
          [`guardiancategory_1`]: i_guardiancategory,
          [`guardianpan_1`]: i_guardianpan,
          [`guardianmobile_1`]: i_guadianmobile,
          [`guardianemail_1`]: i_guardianemail,
          [`guardianemailFamily_1`]: i_guardianEmailFlag,
          [`guardianmobileFamily_1`]: i_guardianMobileFlag,
          [`guardianRelationship_1`]: i_guardianrelationship,
        }),
      });
      setInvestorType({
        investorType: typeofinvestor === "M" ? "minor" : "individual",
      });
      setDisabledFields((prev) => {
        return {
          ...prev,
          pan_1: typeofinvestor != "M" ? true : false,
          guardianpan_1: typeofinvestor == "M" ? true : false,
          kycCompleted_1: true,
          status_1: true,
          // name_1: investortype.investorType != "minor" ? true : false,
        };
      });
    } else if (props.kycData && props.kycData.invname) {
      setFormValues((prev) => {
        return { ...prev, name_1: props.kycData.invname };
      });
    }
  };
  const firstRender = async () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    const params = {
      opt: "A",
      schemetype: props.userId,
    };
    const countriesResponse = await props.getCountriesList();
    const countriesList = countriesResponse?.Dtinformation?.length
      ? countriesResponse.Dtinformation.filter(
          (ele) => ele.countryValue !== "INDIA"
        )
      : [];
    const countriesMasters = countriesList.map((country) => {
      return { label: country.country_name, value: country.country_name };
    });
    setCountries(countriesMasters);
    const response = await props.getNewPurchaseFundList(params);
    const { Dtinformation } = response;
    const amcList = Dtinformation.map((item) => ({
      value: item.amc_code,
      label: item.amc_name,
    }));
    setamcList(amcList);
    if (!!props.location.state) {
      props.storePan(props.location.state.pan);
    }
    await prefillFormValues();
    await checkReduxStore();
  };

  useEffect(() => {
    firstRender();
  }, []);
  const handleInvestor = async (e) => {
    if (investortype.investorType === e.target.value) return;
    setInvestorType({ investorType: e.target.value });
    const isCart = Boolean(
      state && (state?.cartItems?.length || state?.requestBody)
    );
    const isCartMultiple = isCart && state?.cartItems?.length;
    const isCartSingle = isCart && !isCartMultiple;

    if (e.target.value === "minor") {
      setCachedState({
        individual: formValues,
      });
      setDisabledFields((prev) => ({
        ...prev,
        guardianpan_1: false,
        pan_1: false,
        emailFamily_1: false,
        mobileFamily_1: false,
        mobile_1: false,
        email_1: false,
      }));
      setFormValues((prev) => {
        return {
          ...prev,
          guardianpan_1: props.store_pan,
          guardianname_1: formValues.name_1,
          guardiandob_1: formValues.dob_1,
          guardianemail_1: formValues.email_1,
          guardianmobile_1: formValues.mobile_1,
          guardianemailFamily_1: prev.emailFamily_1,
          guardianmobileFamily_1: prev.mobileFamily_1,
          [`modeOfHolding`]: SINGLE_APPLICANT,
          [`name_1`]: "",
          [`pan_1`]: "",
          [`dob_1`]: "",
          [`gender_1`]: "",
          [`email_1`]: "",
          [`mobile_1`]: "",
          [`category_1`]: "",
          [`emailFamily_1`]: "",
          [`mobileFamily_1`]: "",
          ...cachedState?.minor,
        };
      });
      return;
    }
    setCachedState({ minor: formValues });
    setFormValues((prev) => {
      return {
        ...prev,
        modeOfHolding: SINGLE_APPLICANT,
        pan_1: props.store_pan ? props.store_pan : formValues.guardianpan_1,
        name_1: formValues.guardianname_1,
        email_1: isCartSingle
          ? state.requestBody.email
          : isCartMultiple
          ? state.cartItems[0].payload.email
          : formValues.guardianemail_1,
        mobile_1: isCartSingle
          ? state.requestBody.mobile
          : isCartMultiple
          ? state.cartItems[0].payload.mobile
          : formValues.guardianmobile_1,
        guardianpan_1: "",
        guardianname_1: "",
        mobileFamily_1: "",
        dob_1: "",
        gender_1: "",
        category_1: "",
        emailFamily_1: "",
        ...cachedState?.individual,
      };
    });
    setDisabledFields((prev) => {
      return {
        ...prev,
        pan_1:
          e.target.value === "individual" &&
          cachedState?.individual?.pan_1.length === 10
            ? true
            : false,

        emailFamily_1: isCart,
        mobileFamily_1: isCart,
        email_1: isCart,
        mobile_1: isCart,
      };
    });
  };
  const convertDateFormat = (originalDate) => {
    const [month, day, year] = originalDate.split("/");

    const convertedDate = `${day}/${month}/${year}`;

    return convertedDate;
  };

  const submit = async () => {
    const errors = [];

    for (let field of allFields) {
      const error = await validateField(field, formValues[field.key]);
      if (error) {
        errors.push(error);
      }
    }
    const isValid = errors.filter((e) => !!e).length === 0;
    const getStatus = (category) => (category === "20" ? "NRI" : "RI");
    const getInvStatus = (category) => (!!category ? getStatus(category) : "");
    try {
      if (!!isValid) {
        const payload = {
          pan: formValues.pan_1,
          PanName: formValues.name_1,
          PanDOB: !!formValues.dob_1
            ? convertDateFormat(formValues.dob_1)
            : formValues.dob_1,
          folio: "",
          trType: "New",
          fund: formValues.fund_1 || state.fund,
          scheme: "",
          plan: "",
          guardianPan: formValues.guardianpan_1,
          guardianPanDOB: !!formValues.guardiandob_1
            ? convertDateFormat(formValues.guardiandob_1)
            : formValues.guardiandob_1,
          guardianPanName: formValues.guardianname_1,
          jointHolder1Pan: formValues.pan_2,
          jointHolder1PanName: formValues.name_2,
          jointHolder1PanDOB: !!formValues.dob_2
            ? convertDateFormat(formValues.dob_2)
            : formValues.dob_2,
          jointHolder2Pan: formValues.pan_3,
          jointHolder2PanName: formValues.name_3,
          jointHolder2PanDOB: !!formValues.dob_3
            ? convertDateFormat(formValues.dob_3)
            : formValues.dob_3,
          invStatus: getInvStatus(formValues.category_1),
          JH1_invStatus: "",
          JH2_invStatus: "",
          G_invStatus: getInvStatus(formValues.guardiancategory_1),
        };
        if (formValues.pan_1.charAt(3) !== "H") {
          const panCheckResponse = await props.checkPAN(payload);
          validateResponse(panCheckResponse);
        }
        const ApplicantDetails = {
          fund: formValues.fund_1,
          i_Ckyc1: formValues.kycCompleted_1,
          i_category: formValues.category_1,
          i_dob: formValues.dob_1,
          i_email: formValues.email_1.trim(),
          i_fname: formValues.name_1,
          i_invgender: formValues.gender_1,
          i_mobileno: formValues.mobile_1,
          i_pangno: formValues.pan_1,
          fEmailFlag: formValues.emailFamily_1,
          fMobileFlag: formValues.mobileFamily_1,
          typeofinvestor:
            investortype.investorType === "individual" ? "I" : "M",
          i_genMOH: formValues.modeOfHolding === "single" ? "1" : "4",
          country_code: formValues.countrycode_1,
          fund: formValues.fund_1,
          ...(formValues.category_1 === "20" && {
            i_nriadd1: formValues.address1_1,
            i_nriadd2: formValues.address2_1,
            i_nricity: formValues.city_1,
            i_nristate: formValues.state_1,
            i_nricountry: formValues.country_1,
            i_nrizipcode: formValues.zipCode_1,
          }),
          ...(formValues.category_2 === "20" && {
            i_jhnriadd1: formValues.address1_2,
            i_jhnriadd2: formValues.address2_2,
            i_jhnricity: formValues.city_2,
            i_jhnristate: formValues.state_2,
            i_jhnricountry: formValues.country_2,
          }),
          ...(formValues.category_3 === "20" && {
            i_shnriadd1: formValues.address1_3,
            i_shnriadd2: formValues.address2_3,
            i_shnricity: formValues.city_3,
            i_shnristate: formValues.state_3,
            i_shnricountry: formValues.country_3,
          }),

          ...(formValues.modeOfHolding === "anyone" &&
            formValues.pan_2.length === 10 && {
              i_pangno2: formValues.pan_2,
              i_jholder1: formValues.name_2,
              i_email2: formValues.email_2,
              JHfEmailFlag1: formValues.emailFamily_2,
              JHfMobileFlag1: formValues.mobileFamily_2,
              i_invgender2: formValues.gender_2,
              i_jh1dob: formValues.dob_2,
              i_category2: formValues.category_2,
              i_mobileno2: formValues.mobile_2,
              JHcountry_code1: formValues.countrycode_2,
            }),
          ...(formValues.modeOfHolding === "anyone" &&
            formValues.pan_3.length === 10 && {
              i_pangno3: formValues.pan_3,
              i_jholder2: formValues.name_3,
              i_email3: formValues.email_3,
              JHfEmailFlag2: formValues.emailFamily_3,
              JHfMobileFlag2: formValues.mobileFamily_3,
              i_invgender3: formValues.gender_3,
              i_jh2dob: formValues.dob_3,
              i_category3: formValues.category_3,
              i_mobileno3: formValues.mobile_3,
              JHcountry_code2: formValues.countrycode_3,
            }),
          ...(investortype.investorType === "minor" && {
            i_guardianname: formValues.guardianname_1,
            guard_dob: formValues.guardiandob_1,
            // guard_category: formValues.guardiancategory_1,
            i_guardianpan: formValues.guardianpan_1,
            i_guadianmobile: formValues.guardianmobile_1,
            guard_dob: formValues.guardiandob_1,
            i_guardianemail: formValues.guardianemail_1,
            i_guardianEmailFlag: formValues.guardianemailFamily_1,
            i_guardianMobileFlag: formValues.guardianmobileFamily_1,
            i_guardianrelationship: formValues.guardianRelationship_1,
          }),
        };

        const cartApplicantDetails = {
          personalDetails: {
            modeOfHolding: formValues.modeOfHolding === "single" ? "1" : "4",
            name: formValues.name_1,
            dob: formValues.dob_1,
            pan: formValues.pan_1,
            email: formValues.email_1,
            mobile: formValues.mobile_1,
            taxPayerIdentificationNumber:
              formValues.category_1 === "11" ? formValues.pan_1 : "",
            investorType:
              investortype.investorType === "individual" ? "I" : "M",
            familyMobileFlag: formValues.mobileFamily_1,
            familyEmailFlag: formValues.emailFamily_1,
            category: formValues.category_1,
            gender: formValues.gender_1,
            status:
              formValues.investorType === "minor"
                ? "M"
                : formValues.category_1 === "11"
                ? "I"
                : "N",
            seafarerFlag: formValues.seafarerFlag_1 === "Yes",
            ...(formValues.category_1 === "20" //&& formValues.seafarerFlag_1 === "No"
              ? {
                  nriAddress1: formValues.address1_1,
                  nriAddress2: formValues.address2_1,
                  nriCity: formValues.city_1,
                  nriState: formValues.state_1,
                  nriCountry: formValues.country_1,
                  nriZipCode: formValues.zipCode_1,
                }
              : {}),
            ...(investortype.investorType === "minor"
              ? {
                  guardianName: formValues.guardianname_1,
                  guardianPan: formValues.guardianpan_1,
                  guardianRelation: formValues.guardianRelationship_1,
                  guardianEmailDescription: formValues.guardianemailFamily_1,
                  guardianMobileDescription: formValues.guardianmobileFamily_1,
                  guardianEmail: formValues.guardianemail_1,
                  guardianMobile: formValues.guardianmobile_1,
                  guardianDob: formValues.guardiandob_1,
                  guardianCategory: formValues.guardiancategory_1,
                }
              : {}),
          },
          jointHolders:
            formValues.modeOfHolding === "anyone"
              ? [
                  {
                    jointHolderType: "I",
                    name: formValues.name_2,
                    pan: formValues.pan_2,
                    dob: formValues.dob_2,
                    email: formValues.email_2,
                    mobile: formValues.mobile_2,
                    emailFamilyRelation: formValues.emailFamily_2,
                    mobileFamilyRelation: formValues.mobileFamily_2,
                    category: "",
                    status: "I",
                    gender: formValues.gender_1,
                    taxPayerIdentificationNumber:
                      formValues.category_2 === "11" ? formValues.pan_2 : "",
                    ...(formValues.category_2 === "20"
                      ? {
                          nriAddress1: formValues.address1_2,
                          nriAddress2: formValues.address2_2,
                          nriCity: formValues.city_2,
                          nriState: formValues.state_2,
                        }
                      : {}),
                  },
                ]
              : [],
        };
        if (!!formValues.pan_3) {
          cartApplicantDetails.jointHolders.push({
            jointHolderType: "I",
            name: formValues.name_3,
            pan: formValues.pan_3,
            dob: formValues.dob_3,
            email: formValues.email_3,
            mobile: formValues.mobile_3,
            emailFamilyRelation: formValues.emailFamily_3,
            mobileFamilyRelation: formValues.mobileFamily_3,
            category: "",
            status: "I",
            gender: formValues.gender_2,
            taxPayerIdentificationNumber:
              formValues.category_3 === "11" ? formValues.pan_3 : "",
            ...(formValues.category_3 === "20"
              ? {
                  nriAddress1: formValues.address1_3,
                  nriAddress2: formValues.address2_3,
                  nriCity: formValues.city_3,
                  nriState: formValues.state_3,
                }
              : {}),
          });
        }
        props.storeApplicantParams({
          ...ApplicantDetails,
          cart: cartApplicantDetails,
        });
        props.history.push({
          pathname: "/new-investor-transaction/fatca-details",
          state,
        });
      } else {
        const id = Object.keys(errors[0])[0] + "Field";
        const element = document.getElementById(id);
        element.focus();
        setIsLoading(false);
      }
    } catch (e) {
      alert(e?.message);
    }
    // End of Submit, thank you, visit again.
  };

  function validateResponse(response) {
    if (response.Transaction_allow === "Y") return;
    if (response.PASFlag === "N") {
      throw new Error(response.PASRemarks);
    }
    if (response.PANFlag === "N") {
      throw new Error(response.PANRemarks);
    }
    if (response.PANNameMatch === "N") {
      throw new Error("Entered Primary name does not match with PAN record");
    }
    if (response.JH1_panFlag === "N") {
      throw new Error(response.JH1_panRemarks);
    }
    if (response.JH2_panFlag === "N") {
      throw new Error(response.JH2_panRemarks);
    }
    if (response.G_panFlag === "N") {
      throw new Error(response.G_panRemarks);
    }
    if (response.JH1_PANNameMatch === "N") {
      throw new Error(
        "Entered Joint Holder 1 name does not match with PAN record"
      );
    }
    if (response.JH2_PANNameMatch === "N") {
      throw new Error(
        "Entered  Joint Holder 2 name name does not match with PAN record"
      );
    }
    if (response.G_PANNameMatch === "N") {
      throw new Error("Entered Guardian name does not match with PAN record");
    }
    if (response.PanDOBMatch === "N") {
      throw new Error("Entered Primary DOB does not match with PAN record");
    }
    if (response.JH1_PanDOBMatch === "N") {
      throw new Error(
        "Entered Joint Holder 1 DOB does not match with PAN record"
      );
    }
    if (response.JH2_PanDOBMatch === "N") {
      throw new Error(
        "Entered  Joint Holder 2 DOB name does not match with PAN record"
      );
    }
    if (response.G_PanDOBMatch === "N") {
      throw new Error("Entered Guadian DOB does not match with PAN record");
    }
    throw new Error("Error occured while KYC verification, please try later");
  }

  const setFieldValue = (field_key, value) => {
    setFormValues((values) => ({
      ...values,
      [field_key]: value,
    }));
  };

  const setFieldError = (field_key, errorMessage) => {
    setErrors((errors) => ({
      ...errors,
      [field_key]: errorMessage,
    }));
  };

  const handleChange = (field) => {
    return (e) => {
      const value =
        typeof e == "string"
          ? e
          : field.type === "date"
          ? format(new Date(e), "MM/dd/yyyy")
          : field.key.includes("pan")
          ? e.target.value.toUpperCase()
          : (e.target && e.target.value) || "";
      if (field.key.includes("category")) {
        let countryCode = "+91";
        const status = +value === 11 ? "I" : +value === 20 ? "N" : "";
        const key = field.key.replace("category", "status");
        setFieldValue(key, status);
        if (String(value) === "20") {
          countryCode = "";
        }
        const countryCodeKey = field.key.replace("category", "countrycode");
        setFieldValue(countryCodeKey, countryCode);
      }
      setFieldValue(field.key, value);
      validateField(field, value)
        .then((error) => {
          if (
            field.key.includes("pan") &&
            value &&
            value.length == 10 &&
            !error
          ) {
            const id = field.key + "Field";
            const element = document.getElementById(id);
            element.blur();
            getKycStatus(field)({ target: { value } });
          }
        })
        .catch((err) => {
          console.error(err);
          setFieldValue(field.key, "");
        });
    };
  };

  const handleBlur = (field) => {
    return async (e) => {
      const value =
        typeof e == "string" ? e : (e.target && e.target.value) || "";
      const error = await validateField(field, value);
      if (error) {
        setFieldValue(field.key, "");
      }
    };
  };

  const getKycStatus = (field) => async (e) => {
    const value = e.target.value;
    const n = field.key.split("_")[1];
    if (field.key != "guardianpan_1") {
      setIsLoading(true);
      try {
        const error = await validateField(field, value);

        if (error) {
          return;
        }

        const response = await props.checkKyc({
          fund: "",
          userid: props.userId,
          i_pan: value,
        });
        const {
          DtData: [info],
        } = response;
        if (info.KYCBlock !== "N") {
          +n === 2 ? setDisplayModal1(true) : setDisplayModal2(true);
          setPreviouslyCheckedPAN((val) => ({ ...val, [field.key]: "" }));
          setFormValues((prev) => ({ ...prev, [field.key]: "" }));
          return;
        }
        const kycDetails = await props.getKycDetails({ pan: value });
        const { DtData } = kycDetails;
        const {
          name1,
          gender,
          app_pangno,
          app_occ,
          dob,
          email,
          mobile,
          app_cat,
        } = DtData[0];
        const kycFormValues = {
          [`name_${n}`]: name1,
          [`pan_${n}`]: app_pangno.toUpperCase(),
          [`dob_${n}`]: !!dob
            ? formatDateAsIST(dob.substr(6))
            : "",
          [`gender_${n}`]: gender,
          [`email_${n}`]: email,
          [`mobile_${n}`]: mobile,
          [`kyc_occupation_${n}`]: app_occ,
          [`category_${n}`]: app_cat === "22" ? "20" : app_cat,
          [`status_${n}`]: +app_cat === 11 ? "I" : +app_cat > 20 ? "N" : "",
        };

        setFormValues((prev) => {
          return {
            ...prev,
            ...kycFormValues,
          };
        });
        setDisabledFields((prev) => {
          return {
            ...prev,
            [`kycCompleted_${n}`]: true,
            [`status_${n}`]: true,
          };
        });
      } catch (error) {
        setFormValues((prev) => {
          return {
            ...prev,
            [`name_${n}`]: "",
            [`dob_${n}`]: "",
            [`email_${n}`]: "",
            [`mobile_${n}`]: "",
            [`kyc_occupation_${n}`]: "",
            [`category_${n}`]: "",
            [`status_${n}`]: "",
          };
        });

        setDisabledFields((prev) => {
          return {
            ...prev,
            [`kycCompleted_${n}`]: true,
            [`status_${n}`]: true,
          };
        });
      } finally {
        setIsLoading(false);
      }
    }
  };
  const isMinor = investortype.investorType == "minor";
  const showTypeOfInvestor = invCategory !== "20";

  return (
    <>
      <CustomLoader display={isLoading} />
      {!!props.location.state &&
      props.location.state.pan.charAt(3) !== "H" &&
      showTypeOfInvestor ? (
        <div className="d-flex align-items-center container-margin-first-investor ">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p className="font-weight-bold my-2 mb-0">Type of Investor:</p>
            <div style={{ marginBottom: 20 }}>
              <ChoiceFieldforinvestor
                value={investortype.investorType}
                options={investorOptions}
                onChange={(e) => handleInvestor(e)}
              />
            </div>

            {!isMinor && (
              <>
                <div className="input-field-container ">
                  <div className="input-name" style={{ marginBottom: 0 }}>
                    Mode of Holding*
                  </div>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="Search"
                      name="search"
                      value={formValues["modeOfHolding"]}
                      style={{ flexDirection: "row" }}
                      onChange={(e) => {
                        if (formValues.modeOfHolding !== e.target.value) {
                          removeJointHolderDetails();
                        }
                        setFieldValue("modeOfHolding", e.target.value);
                      }}
                    >
                      <div className="investor-radio-button">
                        <FormControlLabel
                          value="single"
                          control={
                            <Radio
                              className="investor-search-radio"
                              style={{ color: "#007ac8" }}
                            />
                          }
                          className="investor-formcontrol-label"
                          style={{ margin: 0 }}
                        />
                        <div className="investor-form-label">Single</div>
                      </div>
                      <div className="investor-radio-button">
                        <FormControlLabel
                          value="anyone"
                          control={
                            <Radio
                              className="investor-search-radio"
                              style={{ color: "#007ac8" }}
                            />
                          }
                          className="investor-formcontrol-label"
                          style={{ margin: 0 }}
                        />
                        <div className="investor-form-label">
                          Anyone (or) Surviour
                        </div>
                      </div>
                    </RadioGroup>
                  </FormControl>
                </div>
              </>
            )}
          </div>
        </div>
      ) : null}
      <CardComponent title="Investor Details">
        <div className="new-investor-container">
          {applicantFieldList.map((field) => {
            return (
              <React.Fragment key={field.key}>
                <AutoField
                  field={field}
                  value={formValues[field.key]}
                  error={errors[field.key]}
                  onChange={handleChange(field)}
                  onBlur={handleBlur(field)}
                  disabled={disabledFields[field.key]}
                  investorType={investortype.investorType}
                  isHuf={() => {
                    if (
                      field.key === "dob_1" &&
                      formValues["pan_1"].charAt(3) === "H"
                    )
                      return true;
                    else if (
                      field.key === "pan_2" &&
                      formValues["pan_2"].charAt(3) === "H"
                    )
                      return true;
                    else if (
                      field.key === "pan_3" &&
                      formValues["pan_3"].charAt(3) === "H"
                    )
                      return true;
                    else return false;
                  }}
                />
                {!!field.nextEmpty && <div className="p-2 " />}
              </React.Fragment>
            );
          })}
        </div>
        <KycNotDoneDialog
          open={displayModal1}
          close={() => {
            setFieldValue("pan_2", "");
            setDisplayModal1(false);
          }}
          continue={() => gotoEkyc(formValues.pan_2)}
        />
        <KycNotDoneDialog
          open={displayModal2}
          close={() => {
            setFieldValue("pan_3", "");
            setDisplayModal2(false);
          }}
          continue={() => gotoEkyc(formValues.pan_3)}
        />
      </CardComponent>

      <div className="d-flex align-items-center container-margin ">
        <button
          className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
          onClick={submit}
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          disabled={true}
        >
          Back
        </button>
        <button
          className="new-investor-button new-investor-active rounded text-uppercase m-0 ml-4"
          onClick={submit}
        >
          Proceed
        </button>
      </div>
    </>
  );
};

export default connect(
  ({ newinvestor, investor, authReducer }) => {
    const { userId, isCartUser } = authReducer;
    const { applicantparams, store_pan } = newinvestor;
    const { kycData } = investor;
    return {
      applicantparams,
      store_pan,
      kycData,
      userId,
      isCartUser,
    };
  },
  {
    checkPAN,
    getNewPurchaseFundList,
    getCountriesList,
    getStatesList,
    storeApplicantParams,
    getKycDetails,
    checkKyc,
    getCitiesByState,
    getRelationShipList,
    storePan,
  }
)(InvestorDetails);

function ChoiceFieldforinvestor({ value, options, onChange }) {
  return (
    <div className="d-flex align-items-center ">
      {options.map((o, i) => {
        const isActive = o.value == value;
        const handleClick = () => {
          const newValue = o.value;
          onChange({ target: { value: newValue } });
        };
        const isFirst = i == 0;
        const isLast = i == options.length - 1;
        const radius = "6px";
        return (
          <div className={`d-flex align-items-center `} key={i}>
            <div
              className={`${
                isActive ? "bg-primary text-white" : " text-primary"
              } p-2
                  border border-primary
                  `}
              onClick={handleClick}
              style={{
                ...(isFirst && {
                  borderBottomLeftRadius: radius,
                  borderTopLeftRadius: radius,
                }),
                ...(isLast && {
                  borderBottomRightRadius: radius,
                  borderTopRightRadius: radius,
                }),
              }}
            >
              {o.name}
            </div>
          </div>
        );
      })}
    </div>
  );
}
function formatDateAsIST(timestamp) {
  const raw = new Date(
    typeof timestamp === "string" ? parseInt(timestamp) : timestamp
  );
  const istOffset = 5.5 * 60;
  const utc = raw.getTime() + raw.getTimezoneOffset() * 60000;
  const istDate = new Date(utc + istOffset * 60000);
  return format(istDate, "MM/dd/yyyy");
}
